import { render, staticRenderFns } from "./MaidQuotePosted.vue?vue&type=template&id=2f66afc6&"
import script from "./MaidQuotePosted.vue?vue&type=script&lang=js&"
export * from "./MaidQuotePosted.vue?vue&type=script&lang=js&"
import style0 from "./MaidQuotePosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidQuotePosted.vue"
export default component.exports